import adminAlertTemplateApi, { resolveAssetUrl } from './adminAlertTemplate.api';

export const uploadApi = {
  mode: 'api',

  async upload(fileOrDataUri) {
    const url = await adminAlertTemplateApi.upload(fileOrDataUri);
    return resolveAssetUrl(url);
  },
};

export default uploadApi;
